import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";
import { GoTopBtn } from '../components/GoTopBtn';
import './ListingTouchs.css';
import { Server_URL } from "../config.js";

function ListingTouchs() {
  const [touchs, setTouchs] = useState([]);
  const [deleted, setDeleted] = useState(true)
  const [keyin, setKeyin] = useState([]);
  // const { id } = useParams();
  const PdfDrawing = 'TouchDrawing,';
  const PdfSpec = 'TouchSpec,';
  const navigate = useNavigate();

  console.log('into ListingTouchs()');
  useEffect(() => {
    if (deleted) {
      console.log('into ListingTouchs() ', `${Server_URL}/get_touchs_size/All`);
      setDeleted(false)
      axios
        .get(`${Server_URL}/get_touchs_size/All`)
        // .get(`${Server_URL}/show_touchs`)
        // .get('http://localhost:3022/show_touchs')
        // .get('http://localhost:5000/show_touchs')
        // .then((res) => { setTouchs(res.data); console.log(Touchs); })
        .then((res) => { setTouchs(res.data) })
        .catch((err) => console.log(err))
    }
  }, [deleted])

  /*
  function handleDelete(id) {
    axios
      .delete(`${Server_URL}/delete_touch/${id}`)
      // .delete(`http://localhost:3022/delete_touch/${id}`)
      // .delete(`http://localhost:5000/delete_touch/${id}`)
      .then((res) => { setDeleted(true) })
      .catch((err) => console.log(err))
  }
  */

  return (
    // <div className='container-fluid bg-primary vh-100 vw-100'>
    <div className='container-fluid vh-100 vw-100'>
      <div> <h2 className='text-center'>Touch Panel List</h2> </div>
      <div> <h1 className='listingtouch'> </h1> </div>
      <div className='d-flex justify-content-center'>
        <label className='p-1 fs-5'><b>Size : </b></label>
        <input type="text20" placeholder="eg. 9.0,  21.5..." value={keyin} onChange={(e) => setKeyin(e.target.value)} />
        <Link to={`/ListingTouchsBySize/${keyin}`} className='btn btn-success mx-2 fs-5'>Select Touch Size</Link>
        <button className='btn btn-success fs-5' onClick={() => navigate(-1)}>Back</button>
      </div>
      <br />
      <h3 className='text-center'>Touch Panel All</h3>
      {/* <table className='table table-bordered'> */}
      <table className='vw-100'>
        {/* <thead className='m-1 px-1 fs-6 text-center bg-success-subtle'> */}
        <thead className='fs-6 text-center bg-success-subtle'>
          <tr>
            <th>SNo</th> <th>Size</th> <th>-----PartNo-----</th> <th>Ratio</th>
            <th>----CoverOD----</th> <th>----LcmAA----</th> <th>---CoverVA---</th> <th>CGThick</th>
            <th>--SensorOD--</th> <th>--SensorAA--</th> <th>SGThick</th>
            <th>ChnRxTx</th> <th>ControlIC</th>
            {/* <th>CGParam，</th> <th>SensorPN，</th> <th>ConnectorType，</th> */}
            {/* <th>ConnectorType，</th> <th>FpcType，</th> */}
            {/* <th>FWConfig，</th> <th>FWDownload，</th> <th>FWUpgrade，</th> <th>FWVersion，</th> */}
            {/* <th>Resolution，</th> <th>Original，</th> <th>TestBoard，</th> <th>TestDate，</th> */}
            {/* <th>RegistDate，</th> <th>Note</th> */}
            <th>--RegDate--</th> <th>---Note---</th>
            <th>-----------Actions-----------</th>
            <th>--</th>
          </tr>
        </thead>

        <tbody className='m-1 px-1 fs-6 text-center bg-primary-subtle'> {
          touchs.map((touch, i) => {
            // console.log(" touch.SNo :", touch.SNo, " touch.PartNo :", touch.PartNo);
            return (
              <tr key={i++}>
                <td>{touch.SNo}</td> <td>{touch.Size}</td> <td>{touch.PartNo}</td> <td>{touch.Ratio}</td>
                <td>{touch.CoverOD}</td> <td>{touch.LcmAA}</td> <td>{touch.CoverVA}</td> <td>{touch.CoverThick}</td>
                <td>{touch.SensorOD}</td> <td>{touch.SensorAA}</td> <td>{touch.SensorThick}</td>
                <td>{touch.ChannelRxTx}</td> <td>{touch.ControlIC}</td>
                {/* <td>{touch.CGParam}</td> <td>{touch.SensorPN}</td> <td>{touch.CustomerPN}</td> */}
                {/* <td>{touch.ConnectorType}</td> <td>{touch.FpcType}</td> */}
                {/* <td>{touch.FWConfig}</td> <td>{touch.FWDownload}</td> <td>{touch.FWUpgrade}</td> <td>{touch.FWVersion}</td> */}
                {/* <td>{touch.Resolution}</td> <td>{touch.Original}</td> <td>{touch.TestBoard}</td> <td>{touch.TestDate}</td> */}
                <td>{touch.RegistDate}</td> <td>{touch.Note}</td>
                {/* <td>{touch.Note}</td> */}
                <td>
                  <Link to={`/ShowTouchDetail/${touch.SNo}`} className='btn trbtn-success p-1'>Read</Link>
                  <Link to={`/ViewPDF/${PdfDrawing + touch.PartNo}`} className='btn trbtn-success m-1 p-1'>Drawing</Link>
                  <Link to={`/ViewPDF/${PdfSpec + touch.PartNo}`} className='btn trbtn-success p-1'>Spec</Link>
                  {/* <Link to={`/ShowTouchDetail/${touch.SNo}`} className='btn trbtn-success m-1 px-2 py-1'>Read</Link> */}
                </td>
                <td>--</td>
              </tr>
            )
          })
        } </tbody>
      </table>
      <br />
      <div className='d-flex justify-content-center'>
        <label className='p-1 fs-5'><b>Size : </b></label>
        <input type="text20" placeholder="eg. 7.0,  15.0..." value={keyin} onChange={(e) => setKeyin(e.target.value)} required />
        <Link to={`/ListingTouchsBySize/${keyin}`} className='btn btn-success mx-2 fs-5'>Select Touch Size</Link>
        <button className='btn btn-success fs-5' onClick={() => navigate(-1)}>Back</button>
      </div>
      <div> < GoTopBtn /> </div>
    </div>
  )
}

export default ListingTouchs